module.exports = __webpack_public_path__ + "static/media/naka-itabashi-6.1a6c6f13.jpg";